/* TeamCard.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./TeamCard.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { N200 } from '@atlaskit/theme/colors';
var styles = {
  teamforbiddenerrorstatewrapper: "_1bsbnklw _kqswh2mm",
  teamname: "_11c8lodh _1reo15vq _18m915vq _1p1dglyw _c71lckbl _1e0ccj1k",
  membercount: "_syaz1wmz _19pk1b66",
  avatarsection: "_19pkpxbi _18u01i6y",
  descriptionwrapper: "_19pkpxbi _4cvr1h6o _1e0c1txw",
  description: "_1reo15vq _18m915vq _c71l1wqb _1e0ccj1k",
  actionbuttons: "_1bsb1osq _1e0c1txw _1bah1yb4 _19pk1ejb _2hwx10v4 _otyridpf _18u0x0bf",
  wrappedbutton: "_i0dlidpf _16jlkb7n _18u0u2gc",
  morebutton: "_18u0u2gc",
  accesslocksvgwrapper: "_otyr1ejb",
  archiveLozengeWrapper: "_19pk1b66"
};
export var TeamForbiddenErrorStateWrapper = function TeamForbiddenErrorStateWrapper(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.teamforbiddenerrorstatewrapper)
  }, props));
};
export var TeamName = function TeamName(props) {
  return fg('enable_profilecard_h2tag_a11y_fix') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.teamname)
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2",
    children: props.children
  })) : /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.teamname)
  }, props));
};
export var MemberCount = function MemberCount(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.membercount)
  }, props));
};
export var AvatarSection = function AvatarSection(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.avatarsection)
  }, props));
};
export var DescriptionWrapper = function DescriptionWrapper(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.descriptionwrapper)
  }, props));
};
export var Description = function Description(props) {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.description)
  }, /*#__PURE__*/React.createElement(Text, _extends({
    maxLines: 3
  }, props)));
};
export var ActionButtons = function ActionButtons(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.actionbuttons),
    backgroundColor: "elevation.surface.overlay"
  }, props));
};
export var WrappedButton = function WrappedButton(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.wrappedbutton)
  }, props));
};
export var MoreButton = function MoreButton(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.morebutton)
  }, props));
};
export var AccessLockSVGWrapper = function AccessLockSVGWrapper(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    xcss: cx(styles.accesslocksvgwrapper)
  }, props));
};
export var ArchiveLozengeWrapper = function ArchiveLozengeWrapper(props) {
  return /*#__PURE__*/React.createElement(Inline, _extends({
    xcss: cx(styles.archiveLozengeWrapper)
  }, props));
};